module.exports = __webpack_public_path__ + "images/cd85a32aca1288fc2495f9a5f854d3bd-MSW_LineArt_IQ5_PanelPlacement_slide9.png";